import { NotifyManager } from "notify-component";

/**
 * Интерфейс входящих параметров запроса
 */
export interface MakeRequestParams {
    url: string;
    method?: string;
    data?: unknown;
    callback?: (data: unknown) => void;
    errorCallback?: () => void;
    userId: number;
}

const setRequestSchema = (): string => {
    if (process.env.REACT_APP_ENV === "local") {
        return "http";
    } else return process.env.REACT_APP_SOCKET_TLS === "wss" ? "https" : "http";
};

export const makeRequest = (params: MakeRequestParams) => {
    const { url, method, data, callback, userId, errorCallback } = params;

    /**
     * @var {string} schema Если фронт запускается локально, пробросим http.
     * @TODO написать конфиг лучше того, что есть сейчас, с учетом возможности проксирования удаленных чатов
     */
    let schema = setRequestSchema();

    /**
     * @var {string} chatApplicationUrl если фронт запускается локально, укажем, что надлежит явно проставить порт, т.к. запросы к чату могут идти на http
     */
    const chatApplicationUrl: string | undefined =
        process.env.REACT_APP_CHAT_APP_PORT && process.env.REACT_APP_ENV === "local"
            ? process.env.REACT_APP_SOCKET_HOST + ":" + process.env.REACT_APP_CHAT_APP_PORT
            : process.env.REACT_APP_SOCKET_HOST;

    const fullUrl: string = schema + "://" + chatApplicationUrl + "/trigger/" + url;
    console.debug("[makeRequest] Full URL:", fullUrl);

    let api_token = localStorage.getItem("api_token");

    const requestOptions = {
        method: method ?? "POST",
        headers: {
            Authorization: api_token || "",
            UserId: process.env.REACT_APP_ENV + "-" + userId,
            "Content-Type": "application/json",
        },
        keepalive: true,
        body: JSON.stringify(data),
    };

    console.debug("[makeRequest] Request options:", requestOptions);

    try {
        fetch(fullUrl, requestOptions)
            .then((response) => {
                let status = response.status;
                if (status === 403) // не показывать эту ошибку, так как запрос идёт в фоне
                {
                    return {};
                }

                if (!response.ok) {
                    // Если статус не OK, пробрасываем ошибку в catch
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return response.json();
            })
            .then((data: { result?: string; data?: unknown; meta?: { text?: string } }) => {
                if (data?.result === "success") {
                    if (typeof callback === "function") {
                        callback(data?.data);
                    }
                } else {
                    if (data?.meta?.text) {
                        NotifyManager.error("", data?.meta?.text);
                    }

                    if (typeof errorCallback === "function") {
                        errorCallback();
                    }
                }
            })
            .catch((error) => {
                console.error({ title: "[makeRequest] Fetch error:", error: error });
                // Передаем информацию об ошибке в errorCallback
                if (typeof errorCallback === "function") {
                    errorCallback();
                } else {
                    // Если errorCallback не передан, но есть ошибка сети/сертификата,
                    // все равно нужно как-то обработать ошибку
                    console.warn("[makeRequest] No errorCallback provided, error:", error);
                }
            });
    } catch (e) {
        console.error({ title: "[makeRequest] Try-catch error:", error: e });
        if (typeof errorCallback === "function") {
            errorCallback();
        }
    }
};
